import { memo } from 'react';

import { useSessionIdFromParams } from '@doger/chat/modules/chat/router';

import { Conversation } from '../../modules/chat';

export const ChatPage = memo(() => {
  const sessionId = useSessionIdFromParams();

  return <Conversation sessionId={sessionId!} />;
});
